import { render, staticRenderFns } from "./MomentCommentPanel.vue?vue&type=template&id=215195a2&scoped=true"
import script from "./MomentCommentPanel.vue?vue&type=script&lang=js"
export * from "./MomentCommentPanel.vue?vue&type=script&lang=js"
import style0 from "./MomentCommentPanel.vue?vue&type=style&index=0&id=215195a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215195a2",
  null
  
)

export default component.exports